import styles from './resultsTotal.module.css'
import {
  ResultsPerPage,
} from "@elastic/react-search-ui";

type Props = {
  location: {
    name: string
  },
  start: number,
  end: number,
  totalResults: number,
  where: string
}

const ResultsTotal = ({ location, start, end, totalResults, where = 'top' }: Props) => {
  return (
    <div className={`${styles.pageInfo} ${where === 'top' ? '' : styles.extraPad}`}>
      <span className={styles.compact}>{`${start} - ${end} of ${totalResults}`}</span>
      <span className={styles.full}>{`Showing ${start} - ${end} of ${totalResults} retail properties`}</span>
      <div className={styles.div}>
        <span className={styles.full}>with</span>
        <ResultsPerPage view={({ value, onChange }) => (
          <select className={styles.select}
            value={value}
            id={`selectPerPage-${location?.name}-${where}`}
            style={{ display: "inline" }}
            onChange={(e) => {
              onChange(e.target.value)
            }}
            aria-label="number of cards per page"
          >
            {[10, 20, 50, 100].map((size) => (
              <option key={size} value={size} >
                {size}
              </option>
            ))}
          </select>
        )} />
        <label htmlFor={`selectPerPage-${location?.name}-${where}`}>per page</label>
      </div>
    </div>
  );
};


export default ResultsTotal;
